import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-travel-and-tour-approval-status-modal',
  templateUrl: './travel-and-tour-approval-status-modal.component.html',
  styleUrls: ['./travel-and-tour-approval-status-modal.component.scss']
})
export class TravelAndTourApprovalStatusModalComponent implements OnInit {
  approvals: any = [];
  constructor(
    public dialogRef: MatDialogRef<TravelAndTourApprovalStatusModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.approvals = data
   }

  ngOnInit() {
    console.log(this.approvals);
  }
  close() {
    this.dialogRef.close();
  }
}
